/**
 * src/serviceWorkerRegistration.js
 * Call register() from index.js to enable PWA on mobile.
 * SW is registered ONLY when:
 *   - Production build  OR  REACT_APP_SW_DEV=true
 *   - window.innerWidth <= 1024  (mobile/tablet only)
 *   - Browser supports Service Workers
 */

const SW_URL = `${process.env.PUBLIC_URL}/service-worker.js`;

export function register(config = {}) {
  /* Only register on mobile-size screens in production */
  const isMobile = window.innerWidth <= 1024;
  const isProd   = process.env.NODE_ENV === 'production';
  const devForce = process.env.REACT_APP_SW_DEV === 'true';

  if ((!isProd && !devForce) || !isMobile) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SW_URL)
      .then(reg => {
        console.log('[iAssets PWA] Service worker registered:', reg.scope);

        /* Notify when an update is available */
        reg.onupdatefound = () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.onstatechange = () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              if (config.onUpdate) config.onUpdate(reg);
            } else if (sw.state === 'installed') {
              if (config.onSuccess) config.onSuccess(reg);
            }
          };
        };
      })
      .catch(err => console.warn('[iAssets PWA] SW registration failed:', err));
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then(reg => reg.unregister())
    .catch(err => console.warn('[iAssets PWA] SW unregister failed:', err));
}
